module.exports = __webpack_public_path__ + "img/emoji_17.9bbcb124.png";